import { Alert, Snackbar, TextLineOrSkeleton } from '@capsicum/common-web';
import styled from 'styled-components';

export namespace S {
	export const Container = styled.section`
		margin-top: ${({ theme }) => theme.spacings.xxlarge};
		display: flex;
		gap: ${({ theme }) => theme.spacings.small};
		flex-flow: column;
		width: 100%;
		align-items: center;
		padding: ${({ theme }) => `0 ${theme.spacings.xsmall}`};
	`;
	export const AlertWrapper = styled(Alert)`
		width: 100%;
	`;
	export const StyledSnackbar = styled(Snackbar)`
		width: 100%;
	`;
	export const StyledButton = styled.span`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
		cursor: pointer;
	`;
	export const TextAmount = styled.span`
		${({ theme }) => theme.fonts.text.text4};
	`;
	export const TextAmountSkeleton = styled(TextLineOrSkeleton)`
		height: ${({ theme }) => theme.fonts.text.text4['line-height']};
		width: 80px;
	`;
	export const Title = styled.h1`
		width: 100%;
		${({ theme }) => theme.fonts.headings.title5};
		text-align: left;
		margin: 0;
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
	export const Subtitle = styled.h2`
		width: 100%;
		${({ theme }) => theme.fonts.text.text3};
		text-align: left;
		margin: 0;
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
